import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "authForm_title" }
const _hoisted_2 = { class: "authForm_description" }
const _hoisted_3 = { class: "authForm_content" }
const _hoisted_4 = { class: "authForm_input" }
const _hoisted_5 = {
  key: 0,
  class: "authForm_input_error"
}
const _hoisted_6 = {
  key: 0,
  class: "authForm_preloader"
}

import AuthLayout from '@web/platform.v3/layouts/auth.vue'
import PhoneInputV3 from '@web/platform.v3/components/phoneInput.vue'
import AcButton from '@ui-kit/components/AcButton.vue'
import AcPreloader from '@ui-kit/components/AcPreloader.vue'
import AuthEnterWith from '@web/platform.v3/components/auth/enter-with.vue'

import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@web/store'
import { useAuthCatchErrors } from '@web/platform.v3/composables/useAuthCatchErrors'

type PhonePayload = {
  country: string
  countryCallingCode: string
  countryCode: string
  formatted: string
  getMetadata: () => void
  nationalNumber: string
  number: string
  possible: boolean
  valid: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'AuthPhoneForm'
},
  __name: 'auth-phone-form',
  props: {
  isVerify: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {



const props = __props

const router = useRouter()
const store = useStore()

const phone = ref('')
const error = ref('')
const isLoading = ref(false)
const isDisabledButton = ref(true)

const storedPhone = computed(() => store.getters['authV3/phone'])
const isTimerActive = computed(() => store.getters['authV3/isTimerActive'])
const isSendCodeBySMS = computed(() => store.getters['authV3/isSendCodeBySMS'])

const { catchError } = useAuthCatchErrors()

function getPhoneValue (payload: string | PhonePayload | null | undefined): string {
  if (!payload) return ''
  if (typeof payload === 'string') return payload
  const number = payload.number || ''
  const formatted = payload.formatted || ''
  const countryCallingCode = payload.countryCallingCode || ''
  const nationalNumber = payload.nationalNumber || ''
  return number || formatted || `${countryCallingCode}${nationalNumber}` || ''
}

function onValidatePhone (payload: string | PhonePayload | null | undefined) {
  phone.value = getPhoneValue(payload)
  if (typeof payload === 'string') {
    isDisabledButton.value = payload.length === 0
  } else if (payload) {
    isDisabledButton.value = !(payload?.valid ?? false)
  }
}

function onInputPhone (payload: PhonePayload) {
  phone.value = getPhoneValue(payload)
}

const handleContinue = async () => {
  if (isLoading.value) return
  isLoading.value = true
  error.value = ''
  if (storedPhone.value === phone.value && isTimerActive.value) {
    store.commit('authV3/setNeedStartTimer', false)
    store.commit('authV3/setPhoneStatus', 'code')
    return
  }

  try {
    if (props.isVerify) {
      await store.dispatch('authV3/requestPhoneCodeForVerify', phone.value)
    } else {
      await store.dispatch('authV3/requestPhoneCode', { phone: phone.value, useSms: isSendCodeBySMS.value })
    }
    store.commit('authV3/setNeedStartTimer', true)
    store.commit('authV3/setIsSendCodeBySMS', false)
    store.commit('authV3/setPhone', phone.value)
    store.commit('authV3/setPhoneStatus', 'code')
  } catch (e) {
    error.value = catchError(e)
  } finally {
    isLoading.value = false
  }
}

function handleEnterEmail () {
  store.commit('authV3/reset')
  router.replace({ name: 'login', params: { type: 'email' } })
}

watch(storedPhone, () => {
  if (storedPhone.value) {
    phone.value = storedPhone.value
  }
}, {
  immediate: true,
  once: true
})

watch(() => props.isVerify, (newVal) => {
  store.commit('authV3/setIsSendCodeBySMS', newVal)
}, {
  immediate: true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AuthLayout, {
    class: "authForm",
    "show-agreement": !__props.isVerify,
    "show-support": !__props.isVerify
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('auth.form.titlePhone')), 1)
    ]),
    description: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.isVerify ? _ctx.$t('auth.form.descriptionPhoneVerify') : _ctx.$t('auth.form.descriptionPhone')), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "authForm_form",
          onSubmit: _withModifiers(handleContinue, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(PhoneInputV3, {
              "model-value": phone.value,
              onOnValidate: onValidatePhone,
              onOnInput: onInputPhone,
              placeholder: "(000) 000 00 00",
              label: _ctx.$t('auth.phone')
            }, null, 8, ["model-value", "label"]),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createVNode(AcButton, {
              class: "authForm_button-continue",
              type: "submit",
              variant: "tonal",
              block: "",
              disabled: isDisabledButton.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isLoading.value ? _ctx.$t('auth.form.buttonSend') : _ctx.$t('continue')) + " ", 1),
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(AcPreloader)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32),
        (!__props.isVerify)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(AuthEnterWith),
              _createVNode(AcButton, {
                variant: "text",
                color: "gray",
                class: "authForm_enter-email",
                block: "",
                onClick: handleEnterEmail
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('auth.enterByEmail')), 1)
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show-agreement", "show-support"]))
}
}

})